import { render } from "./ChangeBranch.vue?vue&type=template&id=d141f448"
import script from "./ChangeBranch.vue?vue&type=script&lang=js"
export * from "./ChangeBranch.vue?vue&type=script&lang=js"

import exportComponent from "/private/var/www/html/goldenaces-club/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__